import React from 'react';
import SolutionPageLayout from '../../components/solutions/SolutionPageLayout';
import { SOLUTIONS } from '../../data/solutions';

const WorkflowAutomationPage: React.FC = () => (
  <SolutionPageLayout content={SOLUTIONS.automation} />
);

export default WorkflowAutomationPage;
